import { format, differenceInCalendarWeeks } from 'date-fns';

export const expandActivityOccurrences = (activity, rangeStart, rangeEnd) => {
  if (activity.type === 'event' && activity.eventDate) {
    const eventD = new Date(activity.eventDate + 'T00:00:00');
    if (eventD >= rangeStart && eventD <= rangeEnd) {
      const excluded = activity.excludedDates || [];
      if (!excluded.includes(activity.eventDate)) {
        const instanceOverride = activity.instanceOverrides?.[activity.eventDate] || {};
        return [{ date: activity.eventDate, instanceOverride }];
      }
    }
    return [];
  }

  const days = activity.dayOfWeek || [];
  const excluded = activity.excludedDates || [];
  const occurrences = [];

  let d = new Date(rangeStart);
  if (activity.startDate && typeof activity.startDate === 'string') {
    const start = new Date(activity.startDate + 'T00:00:00');
    if (start > d) d = start;
  }

  let endDateObj = null;
  if (activity.endDate && typeof activity.endDate === 'string') {
    endDateObj = new Date(activity.endDate + 'T00:00:00');
  }

  while (d <= rangeEnd) {
    if (endDateObj && d > endDateObj) break;

    const dateStr = format(d, 'yyyy-MM-dd');

    if (activity.frequency === 'monthly') {
      if (d.getDate() === activity.monthlyDayOfMonth && !excluded.includes(dateStr)) {
        const instanceOverride = activity.instanceOverrides?.[dateStr] || {};
        occurrences.push({ date: dateStr, instanceOverride });
      }
    } else if (days.includes(d.getDay()) && !excluded.includes(dateStr)) {
      if (activity.frequency === 'biweekly' && activity.biweeklyStartDate) {
        const anchor = new Date(activity.biweeklyStartDate + 'T00:00:00');
        const weekDiff = differenceInCalendarWeeks(d, anchor, { weekStartsOn: 0 });
        if (Math.abs(weekDiff) % 2 !== 0) {
          d = new Date(d.getTime() + 86400000);
          continue;
        }
      }

      const instanceOverride = activity.instanceOverrides?.[dateStr] || {};
      occurrences.push({ date: dateStr, instanceOverride });
    }
    d = new Date(d.getTime() + 86400000);
  }

  return occurrences;
};
